<template>
  <div class="form-group multiselect-checkbox-form-group">
    <div class="label-wrapper" :class="{ '-required': props.required }">
      <div class="multiselect-checkbox-wrapper">
        <div class="multiselect-checkbox-label">
          {{ $t("overlay.form.required.multiselect") }}
        </div>
        <div class="multiselect-container-options">
          <div class="checkbox">
            <label class="multiselect-option form-check-label">
              <input @click="handleMultiselect(0)" name="multiselect" type="checkbox" :value="$t('overlay.form.multiselect.shipping-time')" />
              <span>{{ $t('overlay.form.multiselect.shipping-time') }}</span>
            </label>
          </div>
          <div class="checkbox">
            <label class="multiselect-option form-check-label">
              <input @click="handleMultiselect(1)" name="multiselect" type="checkbox" :value="$t('overlay.form.multiselect.price')" />
              <span>{{ $t('overlay.form.multiselect.price') }}</span>
            </label>
          </div>
          <div class="checkbox">
            <label class="multiselect-option form-check-label">
              <input @click="handleMultiselect(2)" name="multiselect" type="checkbox" :value="$t('overlay.form.multiselect.add-information')" />
              <span>{{ $t('overlay.form.multiselect.add-information') }}</span>
            </label>
          </div>
          <div class="checkbox">
            <label class="multiselect-option form-check-label">
              <input @click="handleMultiselect(3)" name="multiselect" type="checkbox" :value="$t('overlay.form.multiselect.other')" />
              <span>{{ $t('overlay.form.multiselect.other') }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  required: {
    type: Boolean,
    default: false
  }
})
function handleMultiselect(pos)
{
  const checkbox = document.getElementsByClassName('checkbox')[pos]
  // checkbox tick handling
  if (checkbox.classList.contains('-checked'))
  {
    checkbox.classList.remove('-checked')
  }
  else
  {
    checkbox.classList.add('-checked')
  }

  const multiselectCheckboxFormGroup = document.getElementsByClassName('multiselect-checkbox-form-group')[0]

  if (multiselectCheckboxFormGroup.classList.contains('-error'))
  {
    multiselectCheckboxFormGroup.classList.remove('-error')
  }
}

</script>